/**
 * Safe wrapper for localStorage to prevent SecurityError in restricted environments
 * (e.g. cross-origin iframes, private browsing).
 */
export const safeStorage = {
  getItem: (key) => {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      // Access denied or unavailable
      return null;
    }
  },
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      // Access denied or quota exceeded
    }
  },
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      // Access denied
    }
  },
  clear: () => {
    try {
      localStorage.clear();
    } catch (e) {
      // Access denied
    }
  }
};

